import { Component } from '@angular/core';
import { Icons } from '@levelaccess/design-system';

import { SharedModule } from '../../../../shared/shared.module';
import { SwitcherContentComponent } from '../../../vertical-navigation/navigation-context-switcher/switcher-content/switcher-content.component';

@Component({
  imports: [SharedModule, SwitcherContentComponent],
  selector: 'app-switcher-modal',
  templateUrl: './switcher-modal.component.html',
  styleUrls: ['./switcher-modal.component.scss'],
  standalone: true,
})
export class SwitcherModalComponent {
  public Icons: typeof Icons = Icons;
}
